import { withLoadingAndOverlay } from '../../hoc';
import { CustomDataGrid } from '../../components/CustomDataGrid';

function PackageList({ data, columns }) {
  return (
    <CustomDataGrid
      rowId="id"
      columns={columns}
      rows={data}
      footer
    />
  );
}

export default withLoadingAndOverlay(PackageList);
